<template>
    <section id="performing__updates" class="fill-height fill-width">
       <v-container fluid class="">
            <v-row no-gutters class="logo">
                <v-col flat absolute class="py-14 d-flex">
                    <v-img src="/logo_blanc.png" contain max-width="162" ></v-img>
                </v-col>
            </v-row>
            <v-row justify="center" align="center">
                <v-col cols="12" md="6" xl="5" class="d-flex flex-column align-center">
                    <v-avatar color="white" size="84" class="mb-5">
                        <v-icon size="50px" color="primary">
                            mdi-auto-fix
                        </v-icon>
                    </v-avatar>
                    <h1 class="performing-update__title mb-5">
                        ¡Estamos en pleno proceso de mejora!
                    </h1>
                    <div class="text__message">
                        <p class="performing-update__text">
                            Inmatic está llevando a cabo una sesión de mantenimiento para asegurarse de que todo funcione
                            a la perfección. Volveremos a estar en pleno funcionamiento en un abrir y cerrar de ojos.
                        </p>
                        <p class="performing-update__text">
                            Pedimos disculpas por cualquier inconveniente que esto pueda causarte.
                        </p>
                        <p class="performing-update__text">
                            ¡Gracias por tu comprensión y paciencia!
                        </p>
                    </div>
                </v-col>
            </v-row>
       </v-container>
    </section>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "PerformingUpdates",
    mounted(){
        this.changeCrispColor("light_blue");
    },
    methods: {
        ...mapActions({
        changeCrispColor: "changeCrispColor"
        }),
    }
    
};
</script>

<style scoped>
    #performing__updates {
        background-image: url('/inmatic_bg_nohand.jpg');
        background-position: center;
        background-size: cover;
        min-height: 100vh;
        display: flex;
        justify-content: flex-end;
        color: white;
        font-family: 'Roboto', sans-serif !important;
        
    }
    .text__message {
        padding: 0px 90px 0px;
    }
    .performing-update__container {
        position: relative;
    }

    .performing-update__title {
        font-weight: 600;
        font-size: 35px;
        line-height: 50px;
        text-align: center;
        word-wrap: break-word
    }

    .performing-update__text {
        font-weight: 400;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        word-wrap: break-word
    }

    .logo{
        padding: 0px 60px 0px 60px !important;
    }

    @media screen and (max-width: 600px) {
        .logo{
            padding: 0px 10px 0px 10px !important;
        }
        .text__message {
            padding: 0px 20px 0px;
        }
    }
</style>
